import { FC } from "react";
import { FieldErrors } from "react-hook-form";

import { ErrorsDisplayItem } from "./errors-display.item";
import { useAccumulatedTranslatedFormFieldMessages } from "./use-accumulated-translated-form-field-messages";

interface IErrorsDisplayFormsContainer {
  formErrors: FieldErrors | undefined;
}

export const ErrorsDisplayFormsContainer: FC<IErrorsDisplayFormsContainer> = ({
  formErrors,
}: IErrorsDisplayFormsContainer) => {
  const messageList = useAccumulatedTranslatedFormFieldMessages(formErrors);

  return messageList?.map(({ path, message }) => {
    return (
      <ErrorsDisplayItem
        key={`${path}_${message}`}
        errorDescription={message}
      />
    );
  });
};
